const handleCloseStorefrontIFrame = subdomain => {
  const webFrameRef = document.getElementById('web-frame');
  if (webFrameRef) {
    const window = document.getElementById('web-frame').contentWindow;
    window.postMessage('message', subdomain);
  }
};

export default handleCloseStorefrontIFrame;
